
// <-----------------this whole code is for charts , for now they are not in use ------------------>

import axios from "axios";

export const fetchStockData = async (eventName, eventcountry) => {
  try {


    const response = await axios.post(`${process.env.REACT_APP_URL}/graph`, { eventName, eventcountry })

    const data = await response.data.finalData;


    return data;
  } catch (error) {
    console.error("Error fetching stock data:", error);
    throw error;
  }
};

export const fetchCommodityData = async (eventName, eventcountry) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_URL}/graphcommodity`, { eventName, eventcountry })

    const data = await response.data.finalData;

    return data;
  } catch (error) {
    console.error("Error fetching commodity data:", error);
    throw error;
  }
};



// <---hi new code---->